<template>
    <div>
        <md-toolbar class="md-transparent" md-elevation="0">
            <div class="md-layout">
                <div class="md-layout-item">
                    <div class="card-icon">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                    </div>
                    <h4 class="title">Configuration du plan</h4>
                </div>
                <div class="md-layout-actions md-layout-item md-size-40 text-right align-center">
                    <div class="flex items-center justify-end header-actions">
                        <div>
                            <md-button class="md-icon-button md-raised md-warning" @click="$emit('close')">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'times']"></font-awesome-icon>
                            </md-button>
                            <md-tooltip md-direction="top">Fermer</md-tooltip>
                        </div>
                    </div>
                </div>
            </div>
        </md-toolbar>
        <div class="px-5 mt-3">
            <p class="text-sm font-medium mb-2 pl-3.5">Fichier</p>
            <div class="md-layout">
                <div class="md-layout-item md-size-100 old-file" v-if="plan.url">
                    <div class="h-full">
                        <h4 class="mb-1"><b>Fichier actuel</b> (si vous en sélectionnez un autre, celui-ci sera remplacé)</h4>
                        <div class="flex items-center">
                            <div>
                                <md-button class="md-icon-button md-raised md-info" :href="url" target="_blank">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'download']"></font-awesome-icon>
                                </md-button>
                                <md-tooltip md-direction="top">Image</md-tooltip>
                            </div>
                            <div class="ml-2">
                                <md-button class="md-icon-button md-raised md-danger">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'file-pdf']"></font-awesome-icon>
                                </md-button>
                                <md-tooltip md-direction="top">PDF</md-tooltip>
                            </div>
                            <span class="ml-2">{{ formatFilePath(path) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <form @submit.prevent="updatePlanFile">
                <h4 class="mb-0 pl-3.5 mt-4"><b>Nouveau fichier</b></h4>
                <div class="md-layout mt-1">
                    <div class="md-layout-item md-size-85">
                        <md-field class="md-invalid">
                            <label>Fichier</label>
                            <md-file name="file" @change="selectFile"
                                     accept=".jpg,.jpeg,.png"></md-file>
                            <validation-error marge="ml-2" :errors="apiValidationErrors.file"/>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-15">
                        <div class="h-full flex items-center">
                            <div>
                                <md-button type="submit" class="md-icon-button md-raised md-success">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'check']"></font-awesome-icon>
                                </md-button>
                                <md-tooltip md-direction="top">Enregistrer</md-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <md-divider class="mt-5 mb-4 mx-4"></md-divider>
            <form @submit.prevent="updatePlanInfos">
                <div class="md-layout">
                    <div class="md-layout-item md-size-85">
                        <div class="h-full flex items-center">
                            <p class="text-sm font-medium">Informations</p>
                        </div>
                    </div>
                    <div class="md-layout-item md-size-15">
                        <div class="max-w-max">
                            <md-button type="submit" class="md-icon-button md-raised md-success">
                                <font-awesome-icon class="md-icon" :icon="['fa', 'check']"></font-awesome-icon>
                            </md-button>
                            <md-tooltip md-direction="top">Enregistrer</md-tooltip>
                        </div>
                    </div>
                </div>
                <div class="md-layout">
                    <div class="md-layout-item md-size-100">
                        <md-field class="md-invalid">
                            <label>Nom du plan</label>
                            <md-input v-model="plan.name" name="name" type="text" required></md-input>
                            <validation-error :errors="apiValidationErrors.name"/>
                        </md-field>
                    </div>
                </div>
                <div class="md-layout mt-2">
                    <div class="md-layout-item md-size-100">
                        <md-field class="md-invalid">
                            <label>Titre du plan</label>
                            <md-textarea v-model="date" name="title" required md-autogrow></md-textarea>
                            <validation-error :errors="apiValidationErrors.date" />
                        </md-field>
                    </div>
                </div>
            </form>
            <md-divider class="my-5 mx-4"></md-divider>
            <p class="text-sm font-medium mb-2 pl-3.5">Gestion des dispositifs</p>
            <form @submit.prevent="updateDevicesSize">
                <div class="md-layout">
                    <div class="md-layout-item md-size-40">
                        <md-field class="md-invalid">
                            <label>Taille du numéro (en px)</label>
                            <md-input v-model="plan.plan_number" name="number" type="number" required></md-input>
                            <validation-error :errors="apiValidationErrors.number"/>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-45">
                        <md-field class="md-invalid">
                            <label>Taille des pictogramme (en px)</label>
                            <md-input v-model="plan.plan_pictos" name="pictos" type="number" required></md-input>
                            <validation-error :errors="apiValidationErrors.pictos"/>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-15">
                        <div class="h-full flex items-center">
                            <div>
                                <md-button type="submit" class="md-icon-button md-raised md-success">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'check']"></font-awesome-icon>
                                </md-button>
                                <md-tooltip md-direction="top">Enregistrer</md-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <form @submit.prevent="updateDevicesPlacement">
                <div class="md-layout mt-3">
                    <div class="md-layout-item md-size-40">
                        <div class="md-multiselect">
                            <label>Placement du numéro</label>
                            <multiselect v-model="placement"
                                         :options="placements" label="label" track-by="label"
                                         :option-height="104"
                                         placeholder=""
                                         :show-labels="false">
                                <template slot="noOptions">La liste est vide</template>
                                <template slot="noResult">Aucun élement correspondant</template>
                            </multiselect>
                        </div>
                    </div>
                    <div class="md-layout-item md-size-15">
                        <div class="h-full flex items-center">
                            <div>
                                <md-button type="submit" class="md-icon-button md-raised md-success">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'check']"></font-awesome-icon>
                                </md-button>
                                <md-tooltip md-direction="top">Enregistrer</md-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "PlanEditPanel",
    props: {
        plan: Object
    },
    components: {
        ValidationError
    },
    mixins: [formMixin],
    data() {
        return {
            file: null,
            placements: [
                { value: 1, label: 'Gauche' },
                { value: 2, label: 'Haut' },
                { value: 3, label: 'Droite' },
                { value: 4, label: 'Bas' },
            ],
            placement: { value: 4, label: 'Bas' },
            date: _.cloneDeep(this.plan.plan_date),
            url: this.plan.url,
            path: this.plan.path
        }
    },
    methods: {
        async updatePlanFile() {
            this.resetApiValidation()
            if(this.file) {
                let formData = new FormData()
                formData.append('file', this.file)
                formData.append('fileName', this.formatFileName(this.file))
                formData.append('name', this.plan.name)
                formData.append('documentId', this.plan.id)
                try {
                    const { data } = await this.$store.dispatch('site_documents/uploadSitePlan', formData)
                    const pathParts = data.split('/')
                    const filePath = pathParts[4]
                    const { data: plan } =  await this.$store.dispatch('site_documents/updatePlanFile', {
                        documentId: this.plan.id,
                        filePath: filePath
                    })
                    await this.$store.dispatch("alerts/success", "Plan modifiée")
                    await this.emitUpdate()
                    this.file = null
                    this.url = plan.url
                    this.path = plan.path
                } catch (e) {
                    this.setApiValidation(e.response.data.errors)
                }
            } else {
                this.setApiValidation([{
                    detail: 'Le fichier est requis.',
                    source: { pointer: '/data/attributes/file' }
                }])
            }
        },
        async updatePlanInfos() {
            this.resetApiValidation()
            try {
                await this.$store.dispatch('site_documents/updatePlanInfos', {
                    documentId: this.plan.id,
                    name: this.plan.name,
                    plan_date: this.date
                })
                await this.$store.dispatch("alerts/success", "Informations modifiées")
                await this.emitUpdate()
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        },
        async updateDevicesSize() {
            this.resetApiValidation()
            try {
                await this.$store.dispatch('site_documents/updatePlanDevicesSizes', {
                    documentId: this.plan.id,
                    plan_pictos: this.plan.plan_pictos,
                    plan_number: this.plan.plan_number
                })
                await this.$store.dispatch("alerts/success", "Tailles modifiées")
                await this.emitUpdate()
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        },
        async updateDevicesPlacement() {
            this.resetApiValidation()
            try {
                await this.$store.dispatch('site_documents/updatePlanDevicesPlacement', {
                    documentId: this.plan.id,
                    plan_num: this.placement.value
                })
                await this.$store.dispatch("alerts/success", "Placement modifié")
                await this.emitUpdate()
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        },
        emitUpdate() {
            bus.$emit('plan-updated')
        },
        selectFile(e) {
            this.file = e.target.files[0]
        },
        formatFilePath(path = '') {
            return path.slice(5)
        },
        formatFileName(file) {
            let regex = /[ ]|'/g // search space and apostrophe
            return Math.floor(Math.random() * (9999 - 1000 + 1) + 1000) + '-' +
                file.name.toLowerCase().replaceAll(regex, '-')
        },
    },
    mounted() {
        this.file = null
    },
    watch: {
        'plan.plan_date'(newVal) {
            this.date = _.cloneDeep(newVal)
        },
        'plan.path'() {
            this.path = this.plan.path
            this.url = this.plan.url
        }
    }
}
</script>

<style scoped lang="scss">
h4 {
    font-size: .75rem;
}
::v-deep {
    .md-layout-item {
        &.old-file {
            .md-button {
                width: auto;
                margin: 0;
                padding: 5px;
                height: 27px;
                min-width: 27px;
                line-height: 27px;

                .md-icon {
                    font-size: .875rem !important;
                    min-width: .875rem !important;
                    height: .875rem !important;
                }
            }
        }
    }
}
</style>
